/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:12:54
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ title, list = [], color=[] }) => {
  return {
    title: {
      // text: 'World Population'
    },
    color,
    legend: {
      show: true,
      top: 'middle',
      left: 0,
      orient: 'vertical',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: 160,
      right: 0,
      bottom: 20,
      containLabel: false
    },
    xAxis: {
      show: false,
      type: 'category',
      data: title,
      axisLabel: { ...xAxisLabelColor },
    },
    yAxis: {
      name: '数字品牌价值（单位：{db|DB}）',
      nameTextStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#000',
        rich: {
          db: {
            fontSize: 16,
            fontStyle: 'italic'
          }
        },
      },
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLabel: { ...yAxisLabelColor },
    },
    series: list.map((item, i) => {
      const itemStyle = { color: color[i] };

      return {
        name: item.name,
        type: 'bar',
        barGap: 0,
        label: {
          show: true,
          position: 'top',
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: item.list.map(val => ({
          value: val,
          itemStyle,
          emphasis: { itemStyle },
        })),
      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P13/chart.js